import './Tools.scss';

const Tools = () => {
    return(
        <p>Tools</p>
    );
};

export default Tools;